module.exports = __webpack_public_path__ + "media/banner.677080f8.mp4";